import { render, staticRenderFns } from "./MainLedgerBooksList.vue?vue&type=template&id=7330a9e6&scoped=true"
import script from "./MainLedgerBooksList.vue?vue&type=script&lang=js"
export * from "./MainLedgerBooksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7330a9e6",
  null
  
)

export default component.exports